
import { Vue } from "vue-class-component";

export default class Shipment extends Vue {}
